export default "__VITE_ASSET__CPhqFdXr__"